export const serverUrl = {
    baseURL: 'https://api.domo.hk/adminApi/',//正式环境
    uploadUrl: 'https://api.domo.hk/file/uploadObjectOSS',
    imgUrl: 'https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/',
}



// WEBPACK FOOTER //
// ./src/utils/server.js